var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloseCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 17,
    viewBox: "0 0 16 17",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    fillOpacity: 0.2,
    height: 16,
    rx: 8,
    width: 16,
    y: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.7545 5.93117c.3274-.3274.3274-.85822 0-1.18562s-.8583-.3274-1.1857 0l-2.5688 2.56883-2.56883-2.56883c-.3274-.3274-.85822-.3274-1.18562 0s-.3274.85822 0 1.18562l2.56883 2.56883-2.56883 2.5688c-.3274.3274-.3274.8583 0 1.1857s.85822.3274 1.18562 0l2.56883-2.56888 2.5688 2.56888c.3274.3274.8583.3274 1.1857 0s.3273-.8583 0-1.1857l-2.56888-2.5688z",
    fill: "#090719"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/close-circle.4793719d5934702994d4f2ae34f99b75.svg";